import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";

export function useBuscaCep(cep: string) {
  const fetchData = async () => {
    const BUSCA_CEP = `https://viacep.com.br/ws/${cep}/json/`;
    const response = await instance.get(BUSCA_CEP);
    const dataWithPagination = {
      data: response?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: ["busca_cep"],
    refetchOnMount: false,
    enabled: false,
    keepPreviousData: false,
  });
  return query;
}
